import ReactDOM from "react-dom/client";
import "./fonts/Roobert/RoobertFont.css";
import "./index.css";
import App from "./App";
import reportWebVitals from "./reportWebVitals";
import {CacheProvider} from "@emotion/react";
import createCache from "@emotion/cache";
import AuthProvider from "./AuthProvider";
import "swiper/css"

// import i18n (needs to be bundled)
import "./i18n";
import {registerEarlyPushNotificationTapHandlers} from "@/utils/registerEarlyPushNotificationTapHandlers";

registerEarlyPushNotificationTapHandlers();

// Patch ResizeObserver so callbacks run in the next frame, preventing "ResizeObserver loop" errors
// (e.g. from MUI Masonry when note cards toggle edit mode). Must run before any component uses it.
const NativeResizeObserver = window.ResizeObserver;
window.ResizeObserver = class PatchedResizeObserver extends NativeResizeObserver {
	constructor(callback: ResizeObserverCallback) {
		super((entries, observer) => {
			requestAnimationFrame(() => callback(entries, observer));
		});
	}
};

const root = ReactDOM.createRoot(
	document.getElementById("root") as HTMLElement
);

export const muiCache = createCache({
	key: "mui",
	prepend: true
});


root.render(
	<AuthProvider>
		<CacheProvider value={muiCache}>
			<App />
		</CacheProvider>
	</AuthProvider>
);



// If you want to start measuring performance in your app, pass a function
// to log results (for example: reportWebVitals(console.log))
// or send to an analytics endpoint. Learn more: https://bit.ly/CRA-vitals
reportWebVitals();
